import React from 'react'
import Checkbox from 'app/theme/forms/Checkbox'

export default function ListingFuelTypeFilter({ fuelType, setFuelType }) {
  return (
    <div className="my-6 md:my-0">
      <h3 className="text-md text-black font-bold mb-4">Fuel Type</h3>
      <div className="w-full py-2">
        <Checkbox
          label="Gas"
          checked={fuelType ? fuelType.indexOf("gas") >= 0 : false}
          onChange={checked => {
            setFuelType(checked, 'gas')
          }}
        />
      </div>
      <div className="w-full py-2">
        <Checkbox
          label="Diesel"
          checked={fuelType ? fuelType.indexOf("diesel") >= 0 : false}
          onChange={checked => {
            setFuelType(checked, 'diesel')
          }}
        />
      </div>
      {/* <div className="w-full py-2">
        <Checkbox
          label="Electric"
          checked={fuelType ? fuelType.indexOf("electric") >= 0 : false}
          onChange={checked => {
            setFuelType(checked, 'electric')
          }}
        />
      </div> */}
    </div>
  )
}
